// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"40":"TimeslotSelector","129":"MobileLandscape","200":"wix-i18n-config_intl-pluralrules","381":"Chatbot","647":"TimeAgo","653":"ScheduledCallbacksListSelector","710":"PhoneSelector","894":"wix-i18n-config_intl-relativetimeformat","896":"Modal"}[chunkId] + ".chunk.min.js";
};